import axios from 'axios'

const API_PATH = 'api/v2/admins/cms/blog_posts/categories'

const CmsBlogPostCategoriesApiV2 = {
  /**
   * Get list of `Cms Blog Post Categories`
   * @param {object} params uri parameter
   * @return {object} Collection of `Filtered Cms Blog Post Categories`
   */
  get: async (name) => {
    const params   = { name: name }
    const path     = API_PATH
    const response = axios.get(path, { params })
    return response
  }
}

export default CmsBlogPostCategoriesApiV2
